interface FormErrorProps {
  error?: string;
  className?: string;
}

export function FormError({ error, className = "" }: FormErrorProps) {
  if (!error) return null;

  return <p className={`text-sm text-destructive ${className}`}>{error}</p>;
}
